import { useEffect } from 'react';
import type { FacebookPostBlockProps } from './types';

export type { FacebookPostBlockProps };

export function FacebookPostBlock({ linkUrl }: FacebookPostBlockProps) {
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).FB) {
      const script = document.createElement('script');
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      script.async = true;
      script.defer = true;
      script.crossOrigin = 'anonymous';
      document.body.appendChild(script);

      script.onload = () => {
        if ((window as any).FB) {
          (window as any).FB.init({
            xfbml: true,
            version: 'v18.0'
          });
          (window as any).FB.XFBML.parse();
        }
      };
    } else if ((window as any).FB) {
      (window as any).FB.XFBML.parse();
    }
  }, [linkUrl]);

  return (
    <div>
      <div 
        className="fb-post" 
        data-href={linkUrl} 
        data-width="500" 
      />
    </div>
  );
}
